import { NODE_SIZE } from 'modules/org_chart/components/Node/constants'
import type { Coordinates } from 'modules/org_chart/models/Coordinates'
import type { Dimensions } from 'modules/org_chart/models/Dimensions'

export const getTransitionDuration = (
  distance = 0,
  minDistance = 0,
  maxDistance = 3000,
  minDuration = 750,
  maxDuration = 1800
) => {
  if (distance <= minDistance) return minDuration

  if (distance >= maxDistance) return maxDuration

  const percent = (distance - minDistance) / (maxDistance - minDistance)
  const duration = percent * (maxDuration - minDuration) + minDuration

  return Math.floor(duration)
}

export const getCenteredCoordinates = (x: number, y: number, size: Dimensions): Coordinates => {
  const [width, height] = size
  const [nodeWidth, nodeHeight] = NODE_SIZE
  const centeredX = x - (width / 2 - nodeWidth / 2)
  const centeredY = y - (height / 2 - nodeHeight / 2)

  return [centeredX, centeredY]
}
